import accordionStyles from 'components/Accordion/styles.scss';
import { IconArrow } from 'components/Shared/Icon/themes/BGH-RD3/iconArrow';
import { Button } from 'components/Button';
import cn from 'classnames';
import styles from './styles.scss';
import { rm } from 'utils';

interface HeaderProps {
  disabled?: boolean;
  title: string;
  isOpen?: boolean;
  toggleOpen?: () => void;
}

interface SelectionPresenterProps {
  isOpen?: boolean;
}

const ChangeIcon = ({ isOpen }: SelectionPresenterProps) => {
  if (isOpen) {
    return <IconArrow className={styles.arrow} size="tiny" appearance="flip-270" />;
  }

  return <p className={styles.change}>{rm('checkout_overlay_button')}</p>;
};

const Header = ({ disabled, title, isOpen, toggleOpen }: HeaderProps) => (
  <Button
    disabled={disabled}
    onClick={toggleOpen}
    appearance="tertiary"
    className={cn(styles.header, accordionStyles.container)}
  >
    <h3 className={cn(styles.title, accordionStyles.sectionHeader)}>{title}</h3>
    <ChangeIcon isOpen={isOpen} />
  </Button>
);

export { Header };
